import { ArrowDownToLineIcon } from 'lucide-react'

import { ActionRow } from '../../components/action-row/ActionRow'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { WithdrawFromWethAction } from './types'

export interface WithdrawFromWethActionRowProps extends ActionRowBaseProps {
  action: WithdrawFromWethAction
}

export function WithdrawFromWethActionRow({ action, ...props }: WithdrawFromWethActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowDownToLineIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[action.eth]} />
        Unwrap ETH
      </ActionRow.Title>

      <ActionRow.Amount token={action.eth} amount={action.amount} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Unwrap</ActionRow.Trigger>
    </ActionRow>
  )
}
